import { FormattedMessage, useIntl } from 'react-intl';

import { Modal, ResponsiveWidth } from '..';
import { IModalProps } from '..';
import { useStyles } from './unknown-error-modal.styles';
import { Button } from '../../common/button-new';

export const UnknownErrorModal = ({ onClose, ...props }: IModalProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  const handleClose = () => {
    onClose!();
  };

  return (
    <Modal
      {...props}
      onClose={handleClose}
      data-testid="unknown-error-modal"
      title={<FormattedMessage id="common.errors.unknownError.title" />}
      titleStyles={classes.title}
      content={
        <div data-testid="unknown-error-content" className={classes.content}>
          <p data-testid="unknown-error-content-first">
            <FormattedMessage id="common.errors.unknownError.content" />
          </p>
        </div>
      }
      responsiveWidth={ResponsiveWidth.mdWider}
      footer={
        <div className={classes.footerButtons}>
          <Button
            style="dark"
            testId="call-button"
            aria-label={intl.formatMessage({ id: 'order.callSupport.modal.callButton.ariaLabel' })}
            to={intl.formatMessage({ id: 'common.phoneNumber.support.href' })}
            className={classes.phoneButtonLink}
          >
            <FormattedMessage id="common.errors.callSupport" />
          </Button>
          <Button
            style="outlined"
            onClick={handleClose}
            testId="get-button"
            aria-label={intl.formatMessage({ id: 'order.callSupport.modal.getButton.ariaLabel' })}
            rootClasses={classes.confirmButton}
          >
            <FormattedMessage id="order.callSupport.modal.getButton" />
          </Button>
        </div>
      }
    />
  );
};
